import axios from "axios";
import Loader from "components/Common/Loader";
import configure from "configure";
import React, { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import userImg from "../../assets/images/users/AdminImg.png";
import moment from "moment";

const ViewFollowUp = ({ id }) => {
  const [FollowUps, setFollowUps] = useState([]);
  const [Loading, setloading] = useState(false);

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchNotes = async () => {
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios.post(
        `${configure.apiUrl}/leads/follow-up`,
        {
          lead_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res?.data?.success) {
        setloading(false);
        setFollowUps(res?.data?.followUp);
      }
    } catch (e) {
      setloading(false);
      console.log(e);
    } finally {
      setloading(false);
    }
  };

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="mb-3">
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-3 text-dark">Follow Up</CardTitle>

                <div>
                  {FollowUps?.length != 0 ? (
                  <ul className="verti-timeline list-unstyled notes-box">
                    {FollowUps.map((item, index) => (
                      <li key={index} className="event-list position-relative">
                        <div className="event-timeline-dot">
                          <img
                            src={item?.userDetails?.name ? `${configure.marsimg}/${item?.userDetails?.avatar}` :userImg}
                            className="userImg me-3"
                            alt="User"
                          />
                        </div>
                        <div className="d-flex">
                          <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                            <div className="d-flex justify-content-between">
                              <div>
                                <p className="text-muted mb-4">
                                  <h6 className="d-inline me-2">By {item?.userDetails?.name	}</h6>
                                  {moment(item?.created_at).format("YYYY-MM-DD HH:MM:SS")}{" "}
                                  <span className="pl-15">
                                    Got in touch with this Customer at
                                    {" "}{item?.date_time}
                                  </span>
                                </p>
                                <i className="bi bi-triangle-fill note-icon"></i>
                              </div>
                            </div>
                            <div
                              className="Features"
                              dangerouslySetInnerHTML={{
                                __html:
                                  item?.description,
                              }}
                            />
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  ) : null}
                  {FollowUps?.length == 0 ? (
                    <p>No FollowUps has been Added Yet</p>
                  ) : null}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ViewFollowUp;
